// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__dVYuS","author":"Table_author__36SED","authorImage":"Table_authorImage__2Uqlz","unreadRow":"Table_unreadRow__3DgN-"};